module.exports = __webpack_public_path__ + "static/img/72 (3).d19f806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/72 (3).jpg
// module id = TO1D
// module chunks = 0